import * as VacationService from "@/services/vacation";
import useRequest from "@/composables/useRequest";
export default function useVacationSotckPrice(
  product_no,
  selectedCityId,
  selectedMealId,
  selectedStock
) {
  const { state: priceInfo, execute: fetchPrice } = useRequest(
    () =>
      VacationService.getProductPrices({
        product_no,
        departure_id: selectedCityId.value,
        date: selectedStock.value.date,
        set_meal_id: selectedMealId.value
      }),
    {
      prices: [],
      diff_room: {},
      sub_prices: []
    },
    {
      immediate: false
    }
  );

  return {
    priceInfo,
    fetchPrice
  };
}
